import Vue from 'vue'
import store from '@/store'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import Buefy from 'buefy'
import * as VeeValidate from 'vee-validate';
import Dictionary from '@/validators/dictionary'
import axios from 'axios'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import VueCarousel from 'vue-carousel';
import moment from 'moment';
import Cleave from 'cleave.js';
import Multiselect from 'vue-multiselect';

Vue.directive('cleave', (el, binding) => {
    const input = el.querySelector('input')
    new Cleave(input, binding.value)
});

Vue.use(VueCarousel);
Vue.use(Buefy);
Vue.use(Vuex);
Vue.component('multiselect', Multiselect);

Vue.use(VeeValidate, {
  locale: 'pt',
  dictionary: Dictionary
})

if (store.getters.isAuthenticated) {
  Vue.prototype.$cargo = store.getters.cargo
  Vue.prototype.$user_id = store.getters.user

  axios.defaults.headers.common['Authorization'] = 'Bearer ' + store.getters.token
}

Vue.prototype.isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

Vue.prototype.formatData = (data, format) => {
  return moment(data).format(format);
}

Vue.prototype.showFiltersBar = () => {
  var style = document.createElement("style");
      style.innerHTML = `
  .b-table table thead tr:nth-child(2) {
    display: contents !important;
  }
  .lupabusca {
    display: none !important;
  }
  .closeLupa {
    position: relative !important;
    display: inline-flex !important;
  }
  `;
  document.head.appendChild(style);
}
Vue.prototype.hideFiltersBar = () => {
  var style = document.createElement("style");
      style.innerHTML = `
  .b-table table thead tr:nth-child(2) {
    display: none !important;
  }
  .lupabusca {
    position: relative !important;
    display: inline-flex !important;
  }
  .closeLupa {
    display: none !important;
  }
  `;
  document.head.appendChild(style);
}

Vue.prototype.serviceDelete = 
  (confirmationMsg, deleteMsg, service, uuid, toast, rowElement) => {
  if (confirm(confirmationMsg)) { // Confirmation message
    service(uuid) // Service method delete
      .then(() => {
        toast.open({
          duration: 5000,
          message: deleteMsg, // Message on successfully delete
          position: "is-top-right",
          type: "is-success"
        }); // buefy toast
        rowElement.remove(); //<tr> element
      })
      .catch(() => {})
      .finally(() => {
      });
  }
}

Vue.prototype.tableOverrideInputs = 
  (tableElement, funcOnInput, indexes) => {
  
    let parentInputs = tableElement.firstElementChild.lastElementChild;

  for(let i=0; i < indexes.length; i++){
    try {
      // Get Input
      let input = parentInputs.children[indexes[i]].children[0].children[0].children[0];
      
      // Clone Input (to clear all events)
      let cloneInput = input.cloneNode(true);
      
      // Add Events to new input
      cloneInput.addEventListener('input', funcOnInput);
      
      // Replace input
      parentInputs.children[indexes[i]].children[0].children[0].replaceChild(cloneInput, input);
      //alert(indexes[i]);
      /* eslint-disable */
      //console.log(parentInputs);
    } catch(e){
      //alert("error:" + indexes[i]);
      /* eslint-disable */
      //console.log("error");
      //console.log(parentInputs);
      continue;
      //break;
    }
  }
}

Vue.mixin({
  computed: {
    subtitlePage: {
      get: function () {
        var path = this.$route.path;
        var array_path = path.split('/');
        var subtitle = "<ul class='subtitle'>";
        var index;
        for (index = 2; index < array_path.length - 1; index++) {
          subtitle += "<li>" + array_path[index] + "</li> >> ";
        }
        subtitle += "<li>" + array_path[index] + "</li><ul>";
        return subtitle;
      }
    }
  }
})

new Vue({
  render: h => h(App),
  router,
  store,
  components: { App }
}).$mount('#app')